import { expiryMeta, expiryPhrase, expiryShort } from '@/lib/expiry';

/**
 * The expiry state, rendered. One component so a state never looks like one
 * thing in the table and another on a card.
 *
 * variant:
 *   'badge' — the pill: icon + label (the default)
 *   'chip'  — the compact day count, for a dense table cell
 *   'full'  — pill + the sentence, for a detail page
 */
export default function ExpiryBadge({ state, days, variant = 'badge', size = 'sm' }) {
  const meta = expiryMeta(state);
  const Icon = meta.icon;
  const pad = size === 'xs' ? 'px-1.5 py-0.5 text-[11px]' : size === 'lg' ? 'px-3 py-1.5 text-sm' : 'px-2 py-1 text-xs';
  const iconSize = size === 'lg' ? 15 : 12;

  const pill = (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border font-semibold ${pad}`}
      style={{ color: meta.fg, background: meta.bg, borderColor: meta.border }}
    >
      <Icon size={iconSize} strokeWidth={2.5} />
      {meta.label}
    </span>
  );

  if (variant === 'chip') {
    return (
      <span
        className={`nums inline-flex items-center justify-center rounded-md border font-bold ${pad}`}
        style={{ color: meta.fg, background: meta.bg, borderColor: meta.border }}
        title={expiryPhrase(days)}
      >
        {expiryShort(days)}
      </span>
    );
  }

  if (variant === 'full') {
    return (
      <div className="flex flex-wrap items-center gap-2">
        {pill}
        <span className="text-sm text-[var(--app-muted)]">{expiryPhrase(days)}</span>
      </div>
    );
  }

  return pill;
}
